import React from 'react'

import { SidebarItemProps } from './SidebarItem.props'

import { SidebarItemContainer, SidebarItemLabel } from './SidebarItem.styled'

const SidebarItem = ({
  label,
  icon,
  isActive,
  href,
}: SidebarItemProps) => {
  return (
    <SidebarItemContainer to={href} isActive={isActive}>
      {icon()}
      <SidebarItemLabel>{label}</SidebarItemLabel>
    </SidebarItemContainer>
  )
}

export default SidebarItem
